// extracted by mini-css-extract-plugin
export default {"svgWrapper":"styles_svgWrapper__sCRzB","svgIcon":"styles_svgIcon__nlndh"};